import React, { Fragment, useState } from 'react';
import { useTranslate } from 'react-admin';
import MappingsForm from './MappingsForm';
import { Drawer, CreateButton } from '~/components';
import { CreateForm } from '~/components/ra';
import { usePermissions } from 'react-admin';

const l = (key: string): string => `resources.menu.fields.${key}`;

const MappingsCreate = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const { permissions } = usePermissions();
  if (!permissions) return null;
  return (
    <Fragment>
      <CreateButton
        onClick={handleOpen}
        variant='add'
        disabled={!permissions.includes('dynamicMenu.create')}
      />
      <Drawer heading={t('addMapping')} open={open} onClose={handleClose}>
        <CreateForm resource='menu/mappings' target='mappings' closeParent={handleClose}>
          <MappingsForm />
        </CreateForm>
      </Drawer>
    </Fragment>
  );
};

export default MappingsCreate;
